/* eslint-disable no-unused-vars */
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-quill/dist/quill.snow.css";
import "nprogress/nprogress.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import App from "./App";
import { AuthProvider } from "./contexts/JWTContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import store from "./store";
import ModulesProvider from "contexts/ModulesContext";
import registerServiceWorker from "react-service-worker";
import { ErrorBoundary } from "react-error-boundary";
import ErrorTryAgain from "components/ErrorTryAgain";
import { StyledEngineProvider } from "@mui/material";
import LastItemProvider from "contexts/LastItemContext";
import { LoadingProvider } from "contexts/LoadingContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const appSW = registerServiceWorker();
const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: 1,
      structuralSharing: true,
    },
  },
});

root.render(
  <>
    {/* <StrictMode> */}
    <HelmetProvider>
      <ErrorBoundary
        FallbackComponent={ErrorTryAgain}
        onReset={() => {
          // reset the state of your app para evitar o erro novamente
        }}
      >
        <ReduxProvider store={store}>
          <StyledEngineProvider injectFirst>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={ptBR}
            >
              <LoadingProvider>
                <ModulesProvider>
                  <SettingsProvider>
                    <QueryClientProvider client={queryClient}>
                      <BrowserRouter>
                        <AuthProvider>
                          <LastItemProvider>
                            <App appServiceWorker={appSW} />
                          </LastItemProvider>
                        </AuthProvider>
                      </BrowserRouter>
                    </QueryClientProvider>
                  </SettingsProvider>
                </ModulesProvider>
              </LoadingProvider>
            </LocalizationProvider>
          </StyledEngineProvider>
        </ReduxProvider>
      </ErrorBoundary>
    </HelmetProvider>
    {/* </StrictMode> */}
  </>
);
